import React from 'react';
import { makeStyles } from '~/UIKit/Style';
import LoaderGif from '~/Assets/Images/Loader/loader.gif';
import { WHITE } from '~/Constants/Colors.constants';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: WHITE,
    minHeight: '100vh',
  },
  gif: {
    maxHeight: 130,
  },
}));

export const JumpingLoader = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.root} data-testid="JumpingLoader">
      <img src={LoaderGif} className={classes.gif} />
    </div>
  );
};
